module.exports = __webpack_public_path__ + "media/images/riders/small/MORGAN_CHARRE-38e90feef2f56e2a87ba87ba7e51e354.png";